/**
 * @generated SignedSource<<255da07c2448c873504c8f2f23b91110>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type useRemoveCustomAssetTypeMutation$variables = {
  id: string;
};
export type useRemoveCustomAssetTypeMutation$data = {
  readonly removeCustomAsset: {
    readonly clientMutationId: string | null | undefined;
  } | null | undefined;
};
export type useRemoveCustomAssetTypeMutation = {
  response: useRemoveCustomAssetTypeMutation$data;
  variables: useRemoveCustomAssetTypeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "RemoveCustomAssetPayload",
    "kind": "LinkedField",
    "name": "removeCustomAsset",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useRemoveCustomAssetTypeMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useRemoveCustomAssetTypeMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "28a786f2a9277495488c0ba53d4e5954",
    "id": null,
    "metadata": {},
    "name": "useRemoveCustomAssetTypeMutation",
    "operationKind": "mutation",
    "text": "mutation useRemoveCustomAssetTypeMutation(\n  $id: ID!\n) {\n  removeCustomAsset(input: {id: $id}) {\n    clientMutationId\n  }\n}\n"
  }
};
})();

(node as any).hash = "9ba513b46146a3393b0781766979c912";

export default node;
